(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-login"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Setup form submission handlers
    formSetup('customer-login-form', 'login-form-block');
    formSetup('recover-password-form', 'recover-password-block');
    
    // Setup navigation handlers
    document.getElementById('back-to-login').addEventListener('click', backToLogin);
    document.getElementById('go-to-recover').addEventListener('click', goToRecover);
    
    // Check which form to show based on form state
    checkFormStateAndDisplay();
  });

  function checkFormStateAndDisplay() {
    const loginBlock = document.getElementById('login-form-block');
    const recoverBlock = document.getElementById('recover-password-block');
    
    // Check if recover form has errors or success message
    const hasRecoverError = document.querySelector('[data-form-error="recover"]');
    const hasRecoverSuccess = document.querySelector('[data-form-success="recover"]');
    
    // Check if login form has errors
    const hasLoginError = document.querySelector('[data-form-error="login"]');
    
    // Show recover form if it has errors or success message
    if (hasRecoverError || hasRecoverSuccess) {
      loginBlock.style.display = 'none';
      recoverBlock.style.display = 'block';
    }
    // Otherwise show login form (default)
    else {
      loginBlock.style.display = 'block';
      recoverBlock.style.display = 'none';
    }
  }

  function formSetup(formId, blockId) {
    const form = document.getElementById(formId);
    
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        // Show loading
        document.getElementById('loading').style.display = 'block';
      });
    }
  }

  function backToLogin(e) {
    e.preventDefault();
    document.getElementById('recover-password-block').style.display = 'none';
    document.getElementById('login-form-block').style.display = 'block';
  }

  function goToRecover(e) {
    e.preventDefault();
    document.getElementById('login-form-block').style.display = 'none';
    document.getElementById('recover-password-block').style.display = 'block';
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const registerForm = document.getElementById('customer-register-form');
    const submitButton = document.getElementById('register-submit-btn');
    const passwordField = document.getElementById('RegisterPassword');
    const confirmPasswordField = document.getElementById('RegisterPasswordConfirmation');
    const passwordMatchError = document.getElementById('password-match-error');
    const firstNameField = document.getElementById('RegisterFirstName');
    const lastNameField = document.getElementById('RegisterLastName');
    const emailField = document.getElementById('RegisterEmail');
    
    // Ripristina i valori salvati se esistono
    if (sessionStorage.getItem('registerFormData')) {
      const savedData = JSON.parse(sessionStorage.getItem('registerFormData'));
      if (firstNameField.value === '') firstNameField.value = savedData.firstName || '';
      if (lastNameField.value === '') lastNameField.value = savedData.lastName || '';
      if (emailField.value === '') emailField.value = savedData.email || '';
      
      // Pulisci i dati salvati dopo averli ripristinati
      sessionStorage.removeItem('registerFormData');
    }
    
    if (registerForm && submitButton) {
      // Previeni il submit del form con Enter
      registerForm.addEventListener('submit', function(e) {
        e.preventDefault();
        return false;
      });
      
      // Gestisci il click del bottone
      submitButton.addEventListener('click', function(e) {
        e.preventDefault();
        
        // Controlla se le password corrispondono
        if (passwordField.value !== confirmPasswordField.value) {
          passwordMatchError.style.display = 'block';
          confirmPasswordField.focus();
          return; // Ferma qui senza fare submit
        }
        
        // Salva i dati del form prima del submit
        const formData = {
          firstName: firstNameField.value,
          lastName: lastNameField.value,
          email: emailField.value
        };
        sessionStorage.setItem('registerFormData', JSON.stringify(formData));
        
        // Nascondi eventuali errori precedenti
        passwordMatchError.style.display = 'none';
        
        // Hide form and show loading
        document.getElementById('loading').style.display = 'block';
        
        // Submit form after a short delay
        setTimeout(function() {
          registerForm.submit();
        }, 250);
      });
      
      // Nascondi l'errore quando l'utente modifica le password
      [passwordField, confirmPasswordField].forEach(field => {
        field.addEventListener('input', function() {
          if (passwordMatchError.style.display === 'block') {
            passwordMatchError.style.display = 'none';
          }
        });
      });
    } else {
      console.log('Register form or submit button not found');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-reset-password"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const resetForm = document.getElementById('reset-password-form');
    const submitButton = document.getElementById('reset-submit-btn');
    const passwordField = document.getElementById('CustomerPassword');
    const confirmPasswordField = document.getElementById('CustomerPasswordConfirmation');
    const passwordMatchError = document.getElementById('password-match-error');

    if (resetForm && submitButton) {
      resetForm.addEventListener('submit', function(e) {
        e.preventDefault();
        return false;
      });

      submitButton.addEventListener('click', function(e) {
        e.preventDefault();

        // Controlla se le password corrispondono
        if (passwordField.value !== confirmPasswordField.value) {
          passwordMatchError.style.display = 'block';
          confirmPasswordField.focus();
          return; // Ferma qui senza fare submit
        }

        // Show loading overlay
        document.getElementById('loading').style.display = 'block';
        
        setTimeout(function() {
          resetForm.submit();
        }, 250);
      });

      // Nascondi l'errore quando l'utente modifica le password
      [passwordField, confirmPasswordField].forEach(field => {
        field.addEventListener('input', function() {
          if (passwordMatchError.style.display === 'block') {
            passwordMatchError.style.display = 'none';
          }
        });
      });
    } else {
      console.log('Reset password form not found');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
